import React, { useContext, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Form, Button, Row, Col, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaEdit, FaEye, FaEyeSlash, FaTrash, FaWrench, FaQuestionCircle, FaUsers, FaSearch, FaPlus, FaTimes, FaUserPlus, FaFileUpload, FaInfoCircle } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import './Manage.scss'
import parkingBackgroundCartoon from '../../resource/img/parkingBackground.jpg'
import _ from 'lodash';
import { addListEmployees, addListUsers, addNewAEmployee, deleteListUsers, deleteUser, fetchAllEmployees, fetchAllParkingLot, fetchUser, fetchUserByUserCode, updateUserInfo } from '../../services/adminService'
import ReactPaginate from 'react-paginate';
import { toast } from 'react-toastify';
import { AdminContext } from '../../context/AdminContext';
import { useSelector } from 'react-redux';

const convertMongoDateToInputDate = (dateVal) => {
    if (!dateVal) return '';
    try {
        const date = new Date(dateVal);
        if (isNaN(date.getTime())) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    } catch {
        return '';
    }
};

const ListEmployees = (props) => {

    const admin = useSelector(state => state.admin)

    const getParkingLotName = (parkingLotId) => {
        if (!parkingLotId) return 'Chưa phân công';
        const lot = parkingLots.find(l => String(l.parkingLotId || l.id) === String(parkingLotId));
        if (lot) {
            const name = lot.parkingLotName || lot.name || `Khu ${parkingLotId}`;
            return `Khu ${name}`;
        }
        return `Khu bãi xe ${parkingLotId}`;
    };

    let validInputDefault = {
        userCode: true,
        name: true,
        gender: true,
        phoneNumber: true,
        email: true,
    }

    let validInputEditDefault = {
        userCode: true,
        name: true,
        phoneNumber: true,
        email: true,
        gender: true,
        dateOfBirth: true,
        address: true,
        password: true,
        repassword: true,
    }

    let defaultDataToAdd = {
        userCode: '',
        name: '',
        gender: '',
        phoneNumber: '',
        email: '',
        accountPassword: '123123123',
        parkingLotId: 1
    }

    let defaultDataToEdit = {
        userCode: '',
        name: '',
        phoneNumber: '',
        email: '',
        gender: '',
        dateOfBirth: '',
        address: '',
        password: '',
        repassword: '',
    }

    const [password, setPassword] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [confirmDelete, setShowConfirmdelete] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true)
    const [userData, setUserData] = useState(defaultDataToAdd)
    const [validInput, setValidInput] = useState(validInputDefault)
    const fileInputRef = useRef(null)
    const [fileUsers, setFileUsers] = useState()

    //state edit
    const [dataBeforeEdit, setDataBeforeEdit] = useState({})
    const [dataDetail, setDataDetail] = useState({})
    const [userDataEdit, setUserDataEdit] = useState(defaultDataToEdit)
    const [validInputEdit, setValidInputEdit] = useState(validInputEditDefault)
    const [isSaveEditDisabled, setIsSaveEditDisabled] = useState(true)
    const [showPassword, setShowPassword] = useState(false)
    const [showRePassword, setShowRePassword] = useState(false)

    //state delete
    const [listUsersToDelete, setListUsersToDelete] = useState([])
    const [checkedItems, setCheckedItems] = useState({});

    //state find
    const [userCodeToFind, setUserCodeToFind] = useState('')
    const [addModeTab, setAddModeTab] = useState('manual')


    //state pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [currentLimit, setCurrentLimit] = useState(10)
    const [listUsers, setListUsers] = useState([])
    const [totalPages, setTotalPages] = useState(0)

    //state parkinglot
    const [parkingLots, setParkingLots] = useState([])

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            <p>Dưới đây là danh sách khu giữ xe tương ứng với mã khu:</p><br />
            {/* <table className="table w-100">
                <thead>
                    <tr>
                        <th>STT</th>
                        <th>Mã khu</th>
                        <th>Vị trí & mô tả</th>
                    </tr>
                </thead>
                <tbody>
                    { (parkingLots && parkingLots.length > 0) &&
                        <>
                            {parkingLots.map((item, index)=>{
                                return (
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{item.parkingLotName}</td>
                                        <td>{item.description}</td>
                                    </tr>
                                )
                            })}
                        </>
                    }
                </tbody>
            </table> */}
            {(parkingLots && parkingLots.length > 0) &&
                <>
                    {parkingLots.map((item, index) => {
                        return (
                            <>
                                <div>
                                    <p>{item.parkingLotName} : {item.description}</p>
                                </div>
                            </>
                        )
                    })}
                </>
            }
        </Tooltip>
    );

    const handleAddUserToListToDelete = (userCode, dataUser) => {
        const isChecked = !checkedItems[userCode];
        setCheckedItems(prevCheckedItems => ({
            ...prevCheckedItems,
            [userCode]: isChecked
        }));

        if (isChecked) {
            setListUsersToDelete(prevSelectedUsers => [...prevSelectedUsers, dataUser]);
        } else {
            setListUsersToDelete(prevSelectedUsers => prevSelectedUsers.filter(user => user.userCode !== userCode));
        }
    };

    const handleOnchangeInput = (value, name) => {
        let _userData = _.cloneDeep(userData)
        _userData[name] = value
        setUserData(_userData)

        if (_userData.userCode === '' && _userData.name === '' && _userData.gender === '' && _userData.phoneNumber === '' && _userData.email === '')
            setIsSaveDisabled(true)
        else
            setIsSaveDisabled(false)
    }

    const handleOnchangeInputEdit = (value, name) => {
        let _userDataEdit = _.cloneDeep(userDataEdit)
        _userDataEdit[name] = value
        setUserDataEdit(_userDataEdit)

        //if(_userDataEdit.userCode === '' && _userDataEdit.name == '' && _userDataEdit.phoneNumber === '' && _userDataEdit.email === '' && ) 
        if (_userDataEdit === defaultDataToEdit) {
            setIsSaveEditDisabled(true)
        } else {
            setIsSaveEditDisabled(false)
        }

    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const toggleRePasswordVisibility = () => {
        setShowRePassword(!showRePassword)
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const isEmptyInputEdit = () => {
        setValidInputEdit(validInputEditDefault)
        let field = ['userCode', 'name', 'phoneNumber', 'email', 'gender', 'dateOfBirth', 'address', 'password', 'repassword',]
        let check = true;
        for (let i = 0; i < field.length; i++) {
            if (!userDataEdit[field[i]]) {
                let _validInputEdit = _.cloneDeep(validInputEditDefault)
                _validInputEdit[field[i]] = false
                setValidInputEdit(_validInputEdit)
                toast.error(`${field[i]} is empty.`)
                check = false;
                break;
            }
        }
        return check;
    }

    const isAldult = (birthDateString) => {
        // Chuyển chuỗi ngày thành đối tượng Date
        const birthDate = new Date(birthDateString);

        // Lấy ngày hiện tại
        const today = new Date();

        // Lấy năm, tháng, ngày từ ngày sinh
        const birthYear = birthDate.getFullYear();
        const birthMonth = birthDate.getMonth();
        const birthDay = birthDate.getDate();

        // Tính tuổi
        let age = today.getFullYear() - birthYear;

        // Kiểm tra xem đã qua sinh nhật năm nay chưa
        const hasHadBirthdayThisYear = today.getMonth() > birthMonth ||
            (today.getMonth() === birthMonth && today.getDate() >= birthDay);

        // Nếu chưa qua sinh nhật năm nay thì giảm tuổi đi 1
        if (!hasHadBirthdayThisYear) {
            age--;
        }

        // Kiểm tra tuổi có đủ 18 không
        return age >= 18;
    }


    const isValidValueEdit = () => {
        const regexCode = /^NV\d{6}$/
        // const regexFullName = 
        const regexPhone = /^0\d{9}$/
        const regexEmail = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{5,16}@gmail\.com$/;
        const regexPwd = /^[\s\S]{7,16}$/;

        if (regexCode.test(userDataEdit['userCode']) === false) {
            toast.error('Mã không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, userCode: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, userCode: true })
        }

        if (regexPhone.test(userDataEdit['phoneNumber']) === false) {
            toast.error('Số điện thoại không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, phoneNumber: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, phoneNumber: true })
        }


        if (regexEmail.test(userDataEdit['email']) === false) {
            toast.error('Email không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, email: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, email: true })
        }



        if (userDataEdit['gender'] === '') {
            toast.error('Không được bỏ trống')
            setValidInputEdit({ ...validInputEditDefault, gender: false })
            return false
        } else {
            setValidInputEdit({ ...validInputEditDefault, gender: true })
        }


        if (!isAldult(userDataEdit['dateOfBirth'])) {
            toast.error('Bạn phải đủ 18 tuổi trở lên để sử dụng dịch vụ này.')
            setValidInputEdit({ ...validInputEditDefault, dateOfBirth: false })
            return false
        } else {
            setValidInputEdit({ ...validInputEditDefault, dateOfBirth: true })
        }


        if (regexPwd.test(userDataEdit['password']) === false) {
            toast.error('Mật khẩu không hợp lệ.')
            setValidInputEdit({ ...validInputEditDefault, password: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, password: true })
        }


        if (userDataEdit['password'] !== userDataEdit['repassword']) {
            toast.error('Mật khẩu không khớp.')
            setValidInputEdit({ ...validInputEditDefault, password: false, repassword: false })
            return false;
        } else {
            setValidInputEdit({ ...validInputEditDefault, password: true, repassword: true })
        }


        return true;
    }

    //add
    const isEmptyInput = () => {
        setValidInput(validInputDefault)
        let field = ['userCode', 'name', 'gender', 'phoneNumber', 'email']
        let check = true;
        for (let i = 0; i < field.length; i++) {
            if (!userData[field[i]]) {
                let _validInput = _.cloneDeep(validInputDefault)
                _validInput[field[i]] = false
                setValidInput(_validInput)
                toast.error(`${field[i]} is empty.`)
                check = false;
                break;
            }
        }
        return check;
    }

    const isValidValue = () => {
        const regexCode = /^NV\d{6}$/
        // const regexFullName = 
        const regexPhone = /^0\d{9}$/
        const regexEmail = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{5,16}@gmail\.com$/;

        if (regexCode.test(userData['userCode']) === false) {
            toast.error('Mã không hợp lệ.')
            setValidInput({ ...validInputDefault, userCode: false })
            return false;
            // }else if(userData['userCode'] === ''){
            //     toast.error('Không được bỏ trống.')
            //     setValidInput({...validInputDefault, userCode: false})
            //     return false;
        } else {
            setValidInput({ ...validInputDefault, userCode: true })
        }

        // if(userData['name'] === ''){
        //     toast.error('Không được bỏ trống.')
        //     setValidInput({...validInputDefault, name: false})
        //     return false
        // }else{
        //     setValidInput({...validInputDefault, name: true})
        // }

        if (userData['gender'] === '') {
            toast.error('Không được bỏ trống')
            setValidInput({ ...validInputDefault, gender: false })
            return false
        } else {
            setValidInput({ ...validInputDefault, gender: true })
        }

        if (regexPhone.test(userData['phoneNumber']) === false) {
            toast.error('Số điện thoại không hợp lệ.')
            setValidInput({ ...validInputDefault, phoneNumber: false })
            return false;
            // }else if(userData['phoneNumber'] === ''){
            //     toast.error('Không được bỏ trống.')
            //     setValidInput({...validInputDefault, phoneNumber: false})
            //     return false;
        } else {
            setValidInput({ ...validInputDefault, phoneNumber: true })
        }


        if (regexEmail.test(userData['email']) === false) {
            toast.error('Email không hợp lệ.')
            setValidInput({ ...validInputDefault, email: false })
            return false;
            // }else if(userData['email'] === ''){
            //     toast.error('Không được bỏ trống.')
            //     setValidInput({...validInputDefault, email: false})
            //     return false;
        } else {
            setValidInput({ ...validInputDefault, email: true })
        }

        return true;
    }


    //handle event

    const handleAddUser = async () => {
        let check = isEmptyInput() && isValidValue()
        if (check) {
            console.log('check data to add: ', userData);
            //setShowAddModal(false); // Close the modal after action
            //setUserData(defaultDataToAdd)
            let response = await addNewAEmployee(userData)
            if (response && response.ok) {
                toast.success(response.message)
                setShowAddModal(false)
                setUserData(defaultDataToAdd)
                await fetchListUsers()
            } else {
                toast.error(response.message)
            }
        }
    };

    const handleAddListUsers = async () => {
        // const fileInput = fileInputRef.current;
        // if (!fileInput || !fileInput.files.length) {
        //     toast.error('Hãy chọn file thích hợp.')
        //     return;
        // }
        const formData = new FormData()
        formData.append('file', fileUsers)
        let response = await addListEmployees(formData)
        console.log('run here');
        console.log('response: ', response);
        if (response && response.ok) {
            toast.success(response.message)
            setShowAddModal(false)
            setFileUsers(null)
            await fetchListUsers()
        } else {
            console.log('run else');
            console.log('response.ok', response);
            toast.error(response.message)
        }
    }

    const handleEditUser = async () => {
        let check = isEmptyInputEdit() && isValidValueEdit()
        let data = userDataEdit
        if (check) {
            console.log('data to edit: ', data);
            console.log('userCode old: ', dataDetail.userCode);
            let response = await updateUserInfo(data, dataDetail.userCode)
            if (response && response.ok) {
                toast.success(response.message)
                setShowEditModal(false)
                setUserDataEdit(defaultDataToEdit)
                await fetchListUsers()
            } else {
                toast.error(response.message)
            }
        }
    }

    const handleDeleteAUser = async (data) => {
        console.log('data to delete: ', data);
        let response = await deleteUser(data)
        if (response && response.ok) {
            toast.success(response.message)
            setShowConfirmdelete(false)
            await fetchListUsers()
        } else {
            toast.error(response.message)
        }
        // Close the modal after action
    };

    const handleDeleteListUsers = async () => {
        console.log('listUser to delete: ', listUsersToDelete);
        console.log('password to confirm admin to delete: ', password);
        let adminCode = admin.adminData.adminCode
        let response = await deleteListUsers({ listUsersToDelete, password, adminCode })
        if (response && response.ok) {
            console.log('list isCHecked: ', checkedItems);
            toast.success(response.message)
            setShowDeleteModal(false);
            setListUsersToDelete([])
            setPassword("")
            await fetchListUsers()
        } else {
            toast.error(response.message)
        }
    }

    const handlePageClick = (event) => {
        setCurrentPage(+event.selected + 1)
    }

    const handleFindUserByUserCode = async (userCode) => {
        console.log('userCode to find: ', userCode);
        let response = await fetchUserByUserCode(userCode, 1, 10)
        console.log('response.data: ', response.data);
        if (response && response.ok) {
            toast.info(response.message)
            setTotalPages(response.data.totalPage)
            setListUsers(response.data.dataUsers)
        }
    }


    //fetch data
    const fetchListUsers = async () => {
        console.log('currenpage: ', currentPage, '. current limit: ', currentLimit);
        let response = await fetchAllEmployees(currentPage, currentLimit)
        console.log('listUser: ', response.data.dataUsers);
        if (response && response.ok) {
            setTotalPages(response.data.totalPage)
            setListUsers(response.data.dataUsers)
        }


        //
        const initialCheckedItems = response.data.dataUsers.reduce((acc, user) => {
            acc[user.userCode] = listUsersToDelete.some(u => u.userCode === user.userCode);
            return acc;
        }, {});
        setCheckedItems(initialCheckedItems);


    }

    const fetchDataUser = async (userCode) => {
        let response = await fetchUser(userCode)
        console.log('response fetchDataUser: ', response);
        if (response) {
            setDataDetail(response.data)
        }
    }


    //action: show detail, edit, delete
    const handleShowDetailModal = async (data) => {
        console.log('data to view detail: ', data);
        await fetchDataUser(data.userCode)
        setShowDetailModal(true)
    }

    const handleShowDeleteModal = async (data) => {
        let response = await fetchDataUser(data.userCode)
        // if(response && response.ok){
        //     console.log('data to delete form: ', response.data);
        //     setDataDetail(response.data)
        // }
        setShowConfirmdelete(true)
    }

    const getListParkingLots = async () => {
        let response = await fetchAllParkingLot()
        if (response && response.ok) {
            console.log('list parking lots from server: ', response.data);
            setParkingLots(response.data)
        }
    }

    useEffect(() => {
        fetchListUsers()
        // console.log('listUser: ', listUsers);
    }, [currentPage])

    useEffect(() => {
        getListParkingLots()
    }, [])

    return (
        <div className="user-management-container">
        
            <Helmet>
                <title>Quản lý nhân viên</title>
            </Helmet>
            
            <div className="container-fluid">
                <div className="main-content">
                    
                    {/* Page Header */}
                    <div className="page-header">
                        <h1><FaUsers className="me-3" />Quản lý nhân viên</h1>
                        <p className="subtitle">Quản lý thông tin và quyền hạn của nhân viên trong hệ thống</p>
                    </div>

                    {/* Search & Filter Section */}
                    {/* Controls Section */}
                    <div className="controls-section">
                        <div className="search-controls">
                            <Row className="align-items-center g-2">
                                <Col md={8}>
                                    <div className="search-input-group">
                                        <Form.Control
                                            type="text"
                                            placeholder="Nhập mã nhân viên để tìm kiếm..."
                                            className="search-input"
                                            value={userCodeToFind}
                                            onChange={(e) => setUserCodeToFind(e.target.value)}
                                        />
                                        <i className="bi bi-search search-icon"></i>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="search-buttons d-flex gap-2">
                                        <Button 
                                            variant="primary"
                                            className="rounded-3 px-3 py-2 fw-medium d-flex align-items-center gap-2"
                                            onClick={() => handleFindUserByUserCode(userCodeToFind)}
                                        >
                                            <i className="bi bi-search"></i>
                                            <span>Tìm kiếm</span>
                                        </Button>
                                        <Button 
                                            variant="light"
                                            className="border rounded-3 px-3 py-2 fw-medium text-secondary d-flex align-items-center gap-2"
                                            onClick={() => fetchListUsers()}
                                        >
                                            <i className="bi bi-x-lg"></i>
                                            <span>Hủy</span>
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                <h6 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                                    <i className="bi bi-person-badge-fill text-primary fs-5"></i>
                                    Danh sách nhân viên ({listUsers.length})
                                </h6>
                            </div>
                            
                            <div className="action-buttons d-flex gap-2">
                                <Button 
                                    variant="primary"
                                    className="rounded-3 px-3 py-2 fw-semibold d-flex align-items-center gap-2"
                                    onClick={() => setShowAddModal(true)}
                                >
                                    <i className="bi bi-plus-lg"></i>
                                    <span>Thêm nhân viên</span>
                                </Button>
                                <Button 
                                    variant="outline-danger"
                                    className="rounded-3 px-3 py-2 fw-semibold d-flex align-items-center gap-2"
                                    onClick={() => setShowDeleteModal(true)}
                                    disabled={listUsersToDelete.length === 0}
                                >
                                    <i className="bi bi-trash3"></i>
                                    <span>Xóa đã chọn ({listUsersToDelete.length})</span>
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* Employee Management Table */}
                    <div className="table-responsive">
                        {listUsers && listUsers.length > 0 ? (
                            <table className="modern-table table mb-0">
                                <thead>
                                    <tr>
                                        <th width="50">
                                            <div className="custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        const newCheckedItems = {};
                                                        const newListToDelete = [];
                                                        
                                                        listUsers.forEach(user => {
                                                            newCheckedItems[user.userCode] = isChecked;
                                                            if (isChecked) {
                                                                newListToDelete.push(user);
                                                            }
                                                        });
                                                        
                                                        setCheckedItems(newCheckedItems);
                                                        setListUsersToDelete(newListToDelete);
                                                    }}
                                                />
                                            </div>
                                        </th>
                                        <th>STT</th>
                                        <th>Mã nhân viên</th>
                                        <th>Họ tên</th>
                                        <th>Giới tính</th>
                                        <th>Chức vụ</th>
                                        <th>Khu giữ xe</th>
                                        <th width="120">Thao tác</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listUsers.map((item, index) => (
                                        <tr key={`employee-${index}`}>
                                            <td>
                                                <div className="custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        checked={checkedItems[item.userCode] || false}
                                                        onChange={() => handleAddUserToListToDelete(item.userCode, item)}
                                                    />
                                                </div>
                                            </td>
                                            <td><span className="fw-medium text-secondary">{(currentPage - 1) * currentLimit + index + 1}</span></td>
                                            <td className="user-code">{item?.userCode}</td>
                                            <td className="user-name">{item?.userDetail?.name || 'Chưa cập nhật'}</td>
                                            <td>
                                                <span className={`gender-badge ${item?.userDetail?.gender ? 'male' : 'female'}`}>
                                                    {item?.userDetail?.gender ? 'Nam' : 'Nữ'}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="role-badge">
                                                    {item?.userDetail?.role || 'Nhân viên'}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="badge bg-light text-primary border border-primary-subtle px-2 py-1 fw-bold">
                                                    {getParkingLotName(item?.parkingLotId)}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="action-buttons d-flex gap-1">
                                                    <button
                                                        className="btn btn-sm btn-light border text-success rounded-2 p-1.5"
                                                        onClick={() => handleShowDetailModal(item)}
                                                        title="Xem chi tiết"
                                                    >
                                                        <i className="bi bi-eye"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-light border text-danger rounded-2 p-1.5"
                                                        onClick={() => handleShowDeleteModal(item)}
                                                        title="Xóa nhân viên"
                                                    >
                                                        <i className="bi bi-trash3"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="empty-state text-center py-5">
                                <i className="bi bi-person-badge fs-1 text-muted mb-3 d-block"></i>
                                <h5 className="text-muted">Không có nhân viên nào</h5>
                                <p className="text-muted">Thêm nhân viên mới để bắt đầu quản lý</p>
                                <Button 
                                    variant="primary" 
                                    onClick={() => setShowAddModal(true)}
                                    className="mt-2 rounded-3 px-3 py-2 fw-medium"
                                >
                                    <i className="bi bi-plus-lg me-2"></i>
                                    Thêm nhân viên đầu tiên
                                </Button>
                            </div>
                        )}
                    </div>

                    {/* Pagination */}
                    {totalPages > 0 && (
                        <div className='user-footer'>
                            <ReactPaginate
                                nextLabel="Sau >"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={3}
                                pageCount={totalPages}
                                previousLabel="< Trước"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* Modal view info */}
            <Modal
                size='xl'
                show={showDetailModal && dataDetail}
                onHide={() => setShowDetailModal(false)}
                centered
                className="modern-user-detail-modal"
            >
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fw-bold fs-6 text-dark d-flex align-items-center gap-2">
                        <i className="bi bi-person-badge-fill text-primary fs-5"></i>
                        Thông tin chi tiết nhân viên
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row className="g-4">
                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-card-heading text-primary"></i> Mã nhân viên
                                </Form.Label>
                                <Form.Control type="text" className="fw-bold font-monospace bg-light" value={dataDetail.userCode || ''} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-person-fill text-primary"></i> Họ tên
                                </Form.Label>
                                <Form.Control type="text" className="fw-semibold bg-light" value={dataDetail.name || ''} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-telephone-fill text-primary"></i> Số điện thoại
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.phoneNumber || 'Chưa cập nhật'} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-envelope-fill text-primary"></i> Email
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.email || 'Chưa cập nhật'} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-gender-ambiguous text-primary"></i> Giới tính
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.gender === true || dataDetail.gender === 'Nam' ? 'Nam' : 'Nữ'} readOnly />
                            </Form.Group>
                        </Col>

                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-calendar-event text-primary"></i> Ngày sinh
                                </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className="bg-light" 
                                    value={
                                        dataDetail.dateOfBirth
                                            ? (() => {
                                                try {
                                                    const d = new Date(dataDetail.dateOfBirth);
                                                    return isNaN(d.getTime()) ? dataDetail.dateOfBirth : d.toLocaleDateString('vi-VN');
                                                } catch {
                                                    return dataDetail.dateOfBirth;
                                                }
                                            })()
                                            : 'Chưa cập nhật'
                                    } 
                                    readOnly 
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-geo-alt-fill text-primary"></i> Địa chỉ
                                </Form.Label>
                                <Form.Control type="text" className="bg-light" value={dataDetail.address || 'TP. Hồ Chí Minh'} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-p-square-fill text-primary"></i> Khu vực quản lý bãi xe
                                </Form.Label>
                                <Form.Control type="text" className="bg-light fw-bold text-primary" value={getParkingLotName(dataDetail.parkingLotId)} readOnly />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-image text-primary"></i> Ảnh đại diện
                                </Form.Label>
                                <div className="border rounded-3 p-3 bg-light text-center d-flex align-items-center justify-content-center" style={{ minHeight: "140px" }}>
                                    <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold fs-3 shadow-sm" style={{ width: '64px', height: '64px' }}>
                                        {(dataDetail.name || 'N').charAt(0).toUpperCase()}
                                    </div>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" className="rounded-2 px-3 fw-medium" onClick={() => setShowDetailModal(false)}>
                        <i className="bi bi-x-lg me-1"></i> Đóng
                    </Button>
                    <Button
                        variant="primary"
                        className="rounded-2 px-4 fw-bold shadow-sm"
                        onClick={() => {
                            const target = dataDetail || {};
                            setDataBeforeEdit(target);
                            setUserDataEdit({
                                userCode: target.userCode || '',
                                name: target.name || target.userDetail?.name || '',
                                phoneNumber: target.phoneNumber || target.userDetail?.phoneNumber || '',
                                email: target.email || target.userDetail?.email || '',
                                gender: target.gender === true || target.userDetail?.gender === true || target.gender === 'Nam' ? 'Nam' : 'Nữ',
                                dateOfBirth: target.dateOfBirth || target.userDetail?.dateOfBirth ? convertMongoDateToInputDate(new Date(target.dateOfBirth || target.userDetail?.dateOfBirth)) : '',
                                address: target.address || target.userDetail?.address || '',
                                parkingLotId: target.parkingLotId || '',
                                password: '',
                                repassword: '',
                            });
                            setIsSaveEditDisabled(false);
                            setShowEditModal(true);
                            setShowDetailModal(false);
                        }}
                    >
                        <i className="bi bi-pencil-square me-1"></i> Chỉnh sửa thông tin
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Edit user info */}
            <Modal
                size="xl"
                show={showEditModal && dataDetail}
                onHide={() => setShowEditModal(false)}
                centered
                className="modern-user-detail-modal"
            >
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fw-bold fs-6 text-dark d-flex align-items-center gap-2">
                        <i className="bi bi-pencil-square text-primary fs-5"></i>
                        Chỉnh sửa thông tin nhân viên
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row className="g-3">
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Mã nhân viên</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className={`bg-light font-monospace fw-bold ${validInputEdit.userCode ? '' : 'is-invalid'}`}
                                    value={userDataEdit.userCode || ''}
                                    readOnly
                                    onChange={(e) => handleOnchangeInputEdit(e.target.value, 'userCode')} 
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Họ tên nhân viên</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className={`fw-semibold ${validInputEdit.name ? '' : 'is-invalid'}`}
                                    value={userDataEdit.name || ''}
                                    onChange={(e) => handleOnchangeInputEdit(e.target.value, 'name')} 
                                    placeholder="Nhập họ tên"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Số điện thoại</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className={validInputEdit.phoneNumber ? '' : 'is-invalid'}
                                    value={userDataEdit.phoneNumber || ''}
                                    onChange={(e) => handleOnchangeInputEdit(e.target.value, 'phoneNumber')} 
                                    placeholder="Nhập số điện thoại"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Email liên hệ</Form.Label>
                                <Form.Control 
                                    type="email" 
                                    className={validInputEdit.email ? '' : 'is-invalid'}
                                    value={userDataEdit.email || ''}
                                    onChange={(e) => handleOnchangeInputEdit(e.target.value, 'email')} 
                                    placeholder="Nhập email"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                    <i className="bi bi-p-square-fill text-primary"></i> Khu bãi đỗ xe được giao
                                </Form.Label>
                                <Form.Select
                                    value={userDataEdit.parkingLotId || ''}
                                    onChange={(e) => handleOnchangeInputEdit(e.target.value, 'parkingLotId')}
                                    className="fw-semibold text-primary"
                                >
                                    <option value="">-- Chưa phân công khu bãi --</option>
                                    {parkingLots && parkingLots.map((item, index) => {
                                        const lotId = item.parkingLotId || item.id;
                                        const name = item.parkingLotName || item.name || `Khu ${lotId}`;
                                        return (
                                            <option key={`edit-lot-${index}`} value={lotId}>
                                                Khu {name} {item.description ? `- ${item.description}` : ''}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold d-block">Giới tính</Form.Label>
                                <div className="pt-1">
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        name="gender"
                                        value="Nam"
                                        label="Nam"
                                        checked={userDataEdit.gender === 'Nam'}
                                        onChange={(e) => handleOnchangeInputEdit(e.target.value, "gender")}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        name="gender"
                                        value="Nữ"
                                        label="Nữ"
                                        checked={userDataEdit.gender === 'Nữ'}
                                        onChange={(e) => handleOnchangeInputEdit(e.target.value, "gender")}
                                    />
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Ngày sinh</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    className={validInputEdit.dateOfBirth ? '' : 'is-invalid'}
                                    value={userDataEdit.dateOfBirth || ''}
                                    onChange={(e) => handleOnchangeInputEdit(e.target.value, 'dateOfBirth')} 
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Địa chỉ</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className={validInputEdit.address ? '' : 'is-invalid'}
                                    value={userDataEdit.address || ''}
                                    onChange={(e) => handleOnchangeInputEdit(e.target.value, 'address')} 
                                    placeholder="Nhập địa chỉ"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Mật khẩu mới</Form.Label>
                                <div className="d-flex">
                                    <Form.Control 
                                        type={showPassword ? 'text' : 'password'} 
                                        className={validInputEdit.password ? '' : 'is-invalid'}
                                        value={userDataEdit.password || ''}
                                        onChange={(e) => handleOnchangeInputEdit(e.target.value, 'password')} 
                                        placeholder="Để trống nếu không đổi mật khẩu"
                                    />
                                    <Button
                                        variant="outline-secondary"
                                        onClick={togglePasswordVisibility}
                                        className="ms-2"
                                    >
                                        <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                                    </Button>
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small text-secondary fw-semibold">Nhập lại mật khẩu</Form.Label>
                                <div className="d-flex">
                                    <Form.Control 
                                        type={showRePassword ? 'text' : 'password'} 
                                        className={validInputEdit.repassword ? '' : 'is-invalid'}
                                        value={userDataEdit.repassword || ''}
                                        onChange={(e) => handleOnchangeInputEdit(e.target.value, 'repassword')} 
                                        placeholder="Xác nhận lại mật khẩu"
                                    />
                                    <Button
                                        variant="outline-secondary"
                                        onClick={toggleRePasswordVisibility}
                                        className="ms-2"
                                    >
                                        <i className={showRePassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                                    </Button>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" className="rounded-2 px-3 fw-medium" onClick={() => setShowEditModal(false)}>
                        <i className="bi bi-x-lg me-1"></i> Hủy bỏ
                    </Button>
                    <Button 
                        variant="primary" 
                        className="rounded-2 px-4 fw-bold shadow-sm"
                        onClick={() => handleEditUser()} 
                    >
                        <i className="bi bi-check-lg me-1"></i> Lưu thay đổi
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Add User Modal */}
            <Modal
                show={showAddModal}
                onHide={() => setShowAddModal(false)}
                size="lg"
                centered
                className="modern-user-detail-modal"
            >
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fw-bold fs-6 text-dark d-flex align-items-center gap-2">
                        <i className="bi bi-person-plus-fill text-primary fs-5"></i>
                        Thêm nhân viên mới
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {/* Tab Navigation */}
                    <div className="d-flex gap-2 mb-4 border-bottom pb-2">
                        <Button 
                            variant={addModeTab === 'manual' ? 'primary' : 'light'}
                            className={`rounded-3 px-3 py-2 fw-semibold d-flex align-items-center gap-2 ${addModeTab === 'manual' ? 'shadow-sm' : 'border'}`}
                            onClick={() => setAddModeTab('manual')}
                        >
                            <i className="bi bi-person-lines-fill"></i>
                            <span>Thêm thủ công</span>
                        </Button>
                        <Button 
                            variant={addModeTab === 'excel' ? 'success' : 'light'}
                            className={`rounded-3 px-3 py-2 fw-semibold d-flex align-items-center gap-2 ${addModeTab === 'excel' ? 'shadow-sm text-white' : 'border'}`}
                            onClick={() => setAddModeTab('excel')}
                        >
                            <i className="bi bi-file-earmark-excel-fill"></i>
                            <span>Nhập từ file Excel</span>
                        </Button>
                    </div>

                    {addModeTab === 'manual' ? (
                        <Row className="g-3">
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Mã nhân viên</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        className={`font-monospace fw-bold ${validInput.userCode ? '' : 'is-invalid'}`}
                                        onChange={(e) => handleOnchangeInput(e.target.value, "userCode")} 
                                        placeholder="VD: NV000001"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Họ và tên nhân viên</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        className={validInput.name ? '' : 'is-invalid'}
                                        onChange={(e) => handleOnchangeInput(e.target.value, "name")} 
                                        placeholder="Nhập họ tên đầy đủ"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold d-block">Giới tính</Form.Label>
                                    <div className="pt-1">
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            name="gender"
                                            value="Nam"
                                            label="Nam"
                                            onChange={(e) => handleOnchangeInput(e.target.value, "gender")}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            name="gender"
                                            value="Nữ"
                                            label="Nữ"
                                            onChange={(e) => handleOnchangeInput(e.target.value, "gender")}
                                        />
                                        {!validInput.gender && (
                                            <div className="text-danger small mt-1">Vui lòng chọn giới tính</div>
                                        )}
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Số điện thoại</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        className={validInput.phoneNumber ? '' : 'is-invalid'}
                                        onChange={(e) => handleOnchangeInput(e.target.value, "phoneNumber")} 
                                        placeholder="VD: 0987654321"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold">Email liên hệ</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        className={validInput.email ? '' : 'is-invalid'}
                                        onChange={(e) => handleOnchangeInput(e.target.value, "email")} 
                                        placeholder="VD: example@gmail.com"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-secondary fw-semibold d-flex align-items-center gap-2">
                                        <i className="bi bi-p-square-fill text-primary"></i> Bãi xe phụ trách
                                    </Form.Label>
                                    <Form.Select 
                                        onChange={(e) => handleOnchangeInput(e.target.value, "parkingLotId")}
                                        value={userData.parkingLotId || ''}
                                        className="fw-semibold text-primary"
                                    >
                                        <option value="">-- Chọn khu bãi đỗ xe --</option>
                                        {parkingLots && parkingLots.map((item, index) => {
                                            const lotId = item.parkingLotId || item.id;
                                            const name = item.parkingLotName || item.name || `Khu ${lotId}`;
                                            return (
                                                <option key={`parking-add-${index}`} value={lotId}>
                                                    Khu {name} {item.description ? `- ${item.description}` : ''}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    ) : (
                        <div className="p-4 text-center border rounded-3 bg-light">
                            <i className="bi bi-cloud-arrow-up-fill text-success fs-1 mb-2 d-block"></i>
                            <h6 className="fw-bold text-dark mb-1">Tải lên file danh sách nhân viên</h6>
                            <p className="small text-secondary mb-3">Vui lòng chọn định dạng file <code>.xlsx</code> đúng với biểu mẫu quy định của hệ thống.</p>
                            
                            <div className="d-flex justify-content-center mb-3">
                                <input
                                    type="file"
                                    accept=".xlsx"
                                    ref={fileInputRef}
                                    onChange={(e) => setFileUsers(e.target.files[0])}
                                    className="form-control w-75"
                                />
                            </div>

                            {fileUsers && (
                                <div className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 mb-3 fs-6">
                                    <i className="bi bi-file-earmark-check me-2"></i> {fileUsers.name}
                                </div>
                            )}

                            <div>
                                <Button 
                                    variant="success" 
                                    className="px-4 py-2 rounded-3 fw-bold shadow-sm"
                                    onClick={() => handleAddListUsers()}
                                    disabled={!fileUsers}
                                >
                                    <i className="bi bi-upload me-2"></i>
                                    Xác nhận nhập danh sách Excel
                                </Button>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" className="rounded-2 px-3 fw-medium" onClick={() => setShowAddModal(false)}>
                        <i className="bi bi-x-lg me-1"></i> Hủy bỏ
                    </Button>
                    {addModeTab === 'manual' && (
                        <Button 
                            variant="primary" 
                            className="rounded-2 px-4 fw-bold shadow-sm"
                            onClick={() => handleAddUser()} 
                        >
                            <i className="bi bi-person-plus-fill me-1"></i> Tạo tài khoản nhân viên
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Delete Employees Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fw-bold fs-6 text-danger d-flex align-items-center gap-2">
                        <i className="bi bi-exclamation-triangle-fill fs-5"></i>
                        Xác nhận xóa danh sách nhân viên
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="alert alert-warning border-warning border-opacity-25 rounded-3 d-flex align-items-center gap-3 mb-3">
                        <i className="bi bi-info-circle-fill text-warning fs-4 flex-shrink-0"></i>
                        <div>
                            Bạn có chắc chắn muốn xóa <strong>{listUsersToDelete.length}</strong> nhân viên đã chọn khỏi hệ thống?
                        </div>
                    </div>
                    <Form.Group>
                        <Form.Label className="small text-secondary fw-semibold">Nhập mật khẩu quản trị để xác nhận:</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                            placeholder="Mật khẩu admin..."
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" className="rounded-2 px-3 fw-medium" onClick={() => setShowDeleteModal(false)}>
                        <i className="bi bi-x-lg me-1"></i> Hủy bỏ
                    </Button>
                    <Button 
                        variant="danger" 
                        className="rounded-2 px-4 fw-bold shadow-sm"
                        onClick={() => handleDeleteListUsers()}
                        disabled={!password}
                    >
                        <i className="bi bi-trash3 me-1"></i> Xác nhận xóa
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Confirm Delete Single Employee Modal */}
            <Modal show={confirmDelete} onHide={() => setShowConfirmdelete(false)} centered>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fw-bold fs-6 text-danger d-flex align-items-center gap-2">
                        <i className="bi bi-exclamation-triangle-fill fs-5"></i>
                        Xác nhận xóa nhân viên
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="alert alert-warning border-warning border-opacity-25 rounded-3 d-flex align-items-center gap-3 mb-0">
                        <i className="bi bi-info-circle-fill text-warning fs-4 flex-shrink-0"></i>
                        <div>
                            Bạn có chắc chắn muốn xóa vĩnh viễn nhân viên có mã <strong>{dataDetail.userCode}</strong>?
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button 
                        variant="secondary" 
                        className="rounded-2 px-3 fw-medium"
                        onClick={() => { setShowConfirmdelete(false); setListUsersToDelete([]) }}
                    >
                        <i className="bi bi-x-lg me-1"></i> Hủy bỏ
                    </Button>
                    <Button 
                        variant="danger" 
                        className="rounded-2 px-4 fw-bold shadow-sm"
                        onClick={() => handleDeleteAUser(dataDetail)}
                    >
                        <i className="bi bi-trash3 me-1"></i> Xác nhận xóa
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ListEmployees;